import Image from 'next/image'

import {
  Cursive,
  CurveBanner,
  Header,
  Title,
  Wrapper,
  GradientWrap,
  HeroText,
  BackgroundWrap
} from '~/ui'
import { CursiveBasic } from '~/ui/cursive-basic'

export const NutritionistsExpertSection = () => (
  <>
    <CurveBanner>
      {/* <Header className="text-colorFourteen">Our Team</Header> */}
      <div className="container mx-auto p-0 px-6">
        <h1 className="font-tucker-tub text-4xl font-bold uppercase text-colorFourteen lg:text-header">
          Our Team
        </h1>
      </div>
    </CurveBanner>
    <div className="h-[200px]" />
    <BackgroundWrap
      className="relative mt-[-95px] h-full w-full bg-right-top bg-size-60 lg:bg-[url('/assets/images/slider/Tucker-Tub_We-Know-Dogs.jpg')] lg:pt-[95px]"
      // style={{ backgroundSize: '60% auto' }}
    >
      <div className="absolute top-0 right-0 h-full w-[60%] bg-gradient-to-r from-colorFourteen to-transparent" />
      <GradientWrap className="relative">
        <div className="relative pt-[95px] lg:pt-0">
          <div className="container mx-auto px-6 pt-20 pb-0">
            <div className="">
              <div className="absolute top-0 left-0 block h-full w-full bg-[url('/assets/images/slider/Tucker-Tub_We-Know-Dogs.jpg')] bg-cover bg-top lg:hidden" />
              <div className="absolute top-0 left-0 block h-full w-full bg-gradient-to-t from-colorFourteen to-transparent lg:hidden" />
              <div className="relative">
                {/* <div className="h-[200px]" /> */}
                <Title className="text-colorFifteen">Tucker Tub Nutritionists</Title>
                <CursiveBasic>Science backed expertise</CursiveBasic>
              </div>
            </div>
          </div>
        </div>
        <div className="container mx-auto px-6 pt-0">
          <div className="pb-32">
            <div className="grid grid-cols-4 py-[30px]">
              <div className="col-span-4 space-y-6 font-haboro-soft text-base text-[#FFF7F0] lg:col-span-2">
                <p>
                  Tucker Tub knows dogs, with over 20 years of experience making natural dog food.
                  Over the years, we’ve learned what works best for them, through research, science
                  and testing.
                </p>

                <p>
                  We’ve compiled a team of leading in-house nutritionists that work passionately to
                  create the optimal recipes for your animals. Tucker Tub is a result of science
                  backed expertise from PhD scientists with real life experience raising dogs.{' '}
                </p>

                <p>
                  We want your dogs to benefit from this expertise and experience to lead healthier,
                  happier, longer lives.
                </p>

                <p className="italic">
                  Image: Dr Mark Roberts, Tucker Tub Nutritional Scientist with Wolford
                </p>
              </div>
            </div>
          </div>
        </div>
      </GradientWrap>
    </BackgroundWrap>
    <div className="container mx-auto px-6 pt-0">
      <div className="font-haboro-soft text-[#FFF7F0]">
        <div className="mb-3">
          <Image
            src="/Tucker-Tub-Dr-Mark-Roberts-Dante.jpg"
            width={150}
            height={150}
            alt="Dr Mark Roberts"
            className="rounded-full"
          />
        </div>
        <div className="flex grid-cols-2 flex-col gap-[30px] text-base md:grid">
          <div>
            <h3 className="pt-0 pb-4 text-4xl leading-9">Dr Mark Roberts</h3>
            <p>Nutritional Scientist at Tucker Tub</p>
            <br />
            <p>
              I’ve been involved in companion animal nutrition for many years, both in the
              commercial sector and research. My PhD focused on the instinctive diet selection of
              dogs and the health benefits from consuming a diet rich in protein and fat. In
              addition to these studies, I have spent time conducting research in Alaska, examining
              the feeding habits of wild wolves, how these impact on markers of health, and
              comparing this to domestic dogs, based on what they are fed.
            </p>
          </div>
          <div>
            <p>
              I practice what I preach and feed my kennel of 20 working mid and distance racing
              Seppala Siberian Huskies a diet based primarily on this macronutrient composition. The
              need for superior nutrition is even more imperative for working dogs, with any
              nutritional shortcomings becoming evident quickly.
            </p>
            <br />
            <p>
              My intention, is to continue to provide the best diets possible to dogs, utilising my
              nutritional experience and research background, combined with robust science. I also
              want to share my nutritional knowledge, and explain why a protein and fat based diet,
              is the best approach, to help dogs live long and happy lives!
            </p>
          </div>
        </div>
      </div>
    </div>
  </>
)
